// src/components/modules/columns/Columns.resolver.jsx
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { Columns as ColumnsModule } from "@bw/modules"
import parse from "html-react-parser"

const ensureHttps = (url) => {
  if (!url) return url
  if (url.startsWith("http://")) {
    return url.replace("http://", "https://")
  }
  return url
}

const ContentOnColumns = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
  columns = [],
  numberOfColumns,
  slides,
  carousel_check,
}) => {  
  
  if (typeof window !== "undefined") {
    console.log("DEBUG slides:", slides)
  }

  const contents = (columns || []).map((col) => {
    const title = col?.title ?? null
    const content = col?.text ? parse(col?.text) : null

    // on accepte col.image.localImage ou col.image (fallback)
    const image = col?.image ? {
      ...col.image,
      url: ensureHttps(col.image.url),
    } : null

    const carousel = carousel_check && Array.isArray(slides) && slides.length > 0
      ? slides.map((s) => ({
          image: s.localImage ? s : { ...s, url: ensureHttps(s.url) },
        }))
      : null

    return {
      title,
      content,
      image,
      carousel,
    }
  })

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
    >
      <ColumnsModule
        count={Number(numberOfColumns?.value ?? numberOfColumns ?? 2)}
        contents={contents}
      />
    </Section>
  )
}


export const query = graphql`
  fragment ContentOnColumnsModuleFragment on ContentOnColumnsModule {
    numberOfColumns {
      value
    }
    columns {
      title
      text
      type
      image {
        alt
        has_focus
        localImage {
          childImageSharp {
            gatsbyImageData(width: 672)
          }
        }
      }
    }
    slides {
      alt
      url
      localImage {
        childImageSharp {
          gatsbyImageData(width: 672)
        }
      }
    }
    carousel_check 
  }
`
export { ContentOnColumns }
export default ContentOnColumns